/*
 * Spread onto a div, span or li that behaves like a button, so it can also be
 * reached by keyboard and announced as a control:
 *
 *   <div {...clickable(() => book(slot))}>10:30 am</div>
 *
 * Gives it a role, a tab stop, and Enter/Space handling. A real <button> is
 * still the better answer; this is for the places where swapping the element
 * would drag a stylesheet with it.
 *
 * Pass a label when the element's own text isn't the whole story (an icon, say).
 */
export function clickable(onActivate, label) {
  return {
    role: "button",
    tabIndex: 0,
    "aria-label": label,
    onClick: onActivate,
    onKeyDown: (event) => {
      if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
        event.preventDefault();
        onActivate(event);
      }
    },
  };
}
